import React, { useState } from 'react';
import { arrayOf, bool, number, shape } from 'prop-types';
import { Checkbox, Button, Form, Space, Modal } from 'antd';
import { faBook } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import FroalaEditorView from 'Src/common/components/froalaEditor/froalaEditorView';
import ModalHeader from 'Src/common/components/modalHeader';
import FormWrapper from '../formWrapper';
import './style.scss';

function StepThreeAndFour({ totalSteps, isMentor, services, displayStep }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { programDetails } = window;
  const mainText = isMentor ? 'mentor' : 'mentee';

  const getCurrentStep = () => {
    if (displayStep) {
      return displayStep;
    }

    if (totalSteps === 5) {
      return isMentor ? 3 : 4;
    }
    return 3;
  };

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const getHeader = () => (
    <div>
      <h3 className="arc-H300 mb0">
        {isMentor ? 'What would you like to offer as a mentor?' : 'What are you looking to learn from mentors?'}
      </h3>
      <Button
        onClick={toggleModal}
        size="small"
        className="view-modal-button"
        type="link"
        icon={<FontAwesomeIcon className="mr8 arc-color-primary" icon={faBook} />}>
        View
        {` ${mainText} `}
        handbook
      </Button>
    </div>
  );

  return (
    <div className="mentorship-step-three">
      <FormWrapper totalSteps={totalSteps} step={getCurrentStep()} header={getHeader()}>
        <Form.Item name={`${mainText}_services`} rules={[{ required: true, message: 'Please make a selection' }]}>
          <Checkbox.Group>
            <Space direction="vertical" size="large" className="checkbox-item-wrapper">
              {services?.map((service) => (
                <Checkbox key={service.id} value={service.id}>
                  <Space direction="vertical" size="small" className="checkbox-content-wrapper">
                    <span className="arc-p arc-font-weight-bold">{service.name}</span>
                  </Space>
                </Checkbox>
              ))}
            </Space>
          </Checkbox.Group>
        </Form.Item>
      </FormWrapper>
      <Modal
        className="mentorship-guidelines-modal"
        visible={isModalOpen}
        closable={false}
        onCancel={toggleModal}
        title={<ModalHeader title="Guides" hasBackArrow onArrowClick={toggleModal} />}
        footer={
          <Button onClick={toggleModal} type="primary">
            <I18nCustomFormatter id="proceed-button" />
          </Button>
        }>
        <div>
          <h2 className="arc-H500">
            <I18nCustomFormatter id="mentorship-handbook" />
          </h2>
          <div className="guidelines-wrapper">
            <FroalaEditorView model={programDetails[`${mainText}_guidelines`]} />
          </div>
        </div>
      </Modal>
    </div>
  );
}

StepThreeAndFour.propTypes = {
  displayStep: number,
  isMentor: bool.isRequired,
  services: arrayOf(shape()).isRequired,
  totalSteps: number.isRequired,
};

StepThreeAndFour.defaultProps = {
  displayStep: null,
};

export default StepThreeAndFour;
